import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (consumidores/specs antigos importavam estes nomes). */
export type CertidaoQuitacaoDebitoMedicoJob = ReportJob;
export type CertidaoQuitacaoDebitoMedicoJobStatus = JobStatus;

@Injectable({ providedIn: 'root' })
export class CertidaoQuitacaoDebitoMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certidao-quitacao-debito-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.certidaoQuitacaoDebitoMedico;
}
